import { useEffect, useState } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icon,
} from '@eluve/components';
import { useNamedLogger } from '@eluve/logger';
import { useCaptureEvent } from '@eluve/posthog-react';
import {
  useTenantIdFromParams,
  useUserIdFromSession,
} from '@eluve/session-helpers';

import { useTranscriptionMachineSelector } from '../hooks/useTranscriptionMachine';

export const RecordingFailedDialog = () => {
  const logger = useNamedLogger('RecordingFailedDialog');
  const recordingFailed = useTranscriptionMachineSelector(
    (s) => s.context.recordingFailed,
  );
  const appointmentId = useTranscriptionMachineSelector(
    (s) => s.context.sessionAppointmentId,
  );
  const userId = useUserIdFromSession();
  const tenantId = useTenantIdFromParams();
  const hasFailed = useTranscriptionMachineSelector(
    (s) => s.can({ type: 'RESUME' }) && recordingFailed,
  );

  const [open, setOpen] = useState(hasFailed);
  const captureEvent = useCaptureEvent();

  useEffect(() => {
    setOpen(hasFailed);
  }, [hasFailed]);

  useEffect(() => {
    if (open) {
      logger.warn('RecordingFailedDialog shown', {
        appointmentId,
        userId,
        tenantId,
      });
    }
  }, [open, logger, appointmentId, userId, tenantId]);

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle className="text-bg-negative-strong-primary">
            <Icon name="CircleAlert" size="xl" className="mr-4 inline-flex" />
            {`Session is no longer in progress.`}
          </DialogTitle>
          <DialogDescription>
            {'Refresh the page to resume the session.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            onClick={() => {
              captureEvent('user_reloaded_for_failed_recording', undefined, {
                send_instantly: true,
              });
              setTimeout(() => {
                window.location.reload();
              }, 50);
            }}
          >
            Refresh Page
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
